import { render, staticRenderFns } from "./otherApplicationLogs.vue?vue&type=template&id=23b48ede&scoped=true"
import script from "./otherApplicationLogs.vue?vue&type=script&lang=js"
export * from "./otherApplicationLogs.vue?vue&type=script&lang=js"
import style0 from "./otherApplicationLogs.vue?vue&type=style&index=0&id=23b48ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b48ede",
  null
  
)

export default component.exports